module.exports = __webpack_public_path__ + "img/abbattimento-pesticidi.ffbae13d.jpg";